module.exports = __webpack_public_path__ + "static/media/SM-MT-10.c7243faa.mp3";